import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {CustomDateRange} from '../../common/types/common.types';

export interface ClaimFilterType {
  searchValue?: string;
  searchCriteria?: string[];
  tuneFilters?: string[];
  processingClass?: string;
  processingSubClass?: string;
  claimType?: string;
  createdBy?: string;
  adjudicationStatus?: string;
  processingStage?: string;
  familyOfBenefit?: string;
  pageNumber?: number;
  pageSize?: number;
  sortField?: string;
  sortDirection?: string;
  dateRange?: CustomDateRange;
  tariffCodeList?: string; // Using the same name as backend for auto-mapping in fieldMap
  practiceNumber?: string;
  products?: string[];
}

export enum ClaimFilterKeys {
  SearchClaims = 'searchValue',
  SearchCriteria = 'searchCriteria',
  TuneFilters = 'tuneFilters',
  ProcessingClass = 'processingClass',
  ProcessingSubClass = 'processingSubClass',
  ClaimType = 'claimType',
  CreatedBy = 'createdBy',
  AdjudicationStatus = 'adjudicationStatus',
  ProcessingStage = 'processingStage',
  FamilyOfBenefit = 'familyOfBenefit',
  PageNumber = 'pageNumber',
  PageSize = 'pageSize',
  SortField = 'sortField',
  SortDirection = 'sortDirection',
  DateRange = 'dateRange',
  TariffCodeList = 'tariffCodeList', // Using the same name as backend for auto-mapping in fieldMap
  PracticeNumber = 'practiceNumber',
  Product = 'products'
}

@Injectable({
  providedIn: 'root'
})
export class ClaimFilterCacheService {
  private filterValues: ClaimFilterType = {};
  private readonly cachedFilterValues: BehaviorSubject<ClaimFilterType> = new BehaviorSubject<ClaimFilterType>(null);

  constructor() {
  }

  saveFilterValue(key: string, value: any): void {
    this.filterValues[key] = value;
    this.emitUpdatedValue();
  }

  saveMultipleFilterValue(values: any): void {
    this.filterValues = {...this.filterValues, ...values};
    this.emitUpdatedValue();
  }


  replaceFilterValues(values: ClaimFilterType): void {
    this.filterValues = {...values};
    this.emitUpdatedValue();
  }
  getFilterValue(): Observable<ClaimFilterType> {
    return this.cachedFilterValues.asObservable();
  }

  // Clear the cached value for a specific key
  clearFilterValue(key: string): void {
    delete this.filterValues[key];
    this.emitUpdatedValue();
  }

  private emitUpdatedValue() {
    this.cachedFilterValues.next(this.filterValues);
  }
}
